import { Snackbar } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { Alert, AlertTitle } from "@material-ui/lab";
import React, { useState } from "react";
import { Link } from 'react-router-dom';
import WriteToUsIcon from "../../assets/feather.svg";
import { GradientDiv } from "../../styles/common";
import "./contact.scss";

function Copyright() {
  return (
    <Typography variant="body2" style={{ color:"#9dbecd"}} align="center">
      {"Copyright © "}
      <a style={{ color:"#fafafa"}} href="https://rajatsehgal.com/" target={'_blank'} rel="noopener noreferrer">
        Rajat Sehgal
      </a>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    fontFamily: "poiret",
    marginTop: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: "#f1bace52",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));
interface ResponseMailSend {
  message:string,
  status:string
} 
export default function ContactForm() {
  const classes = useStyles();
  const [emailIsValid, setEmailIsValid] = useState<Boolean>(true);
  const [response, setResponse] = useState<ResponseMailSend | undefined>(undefined);

  const validateEmail = (email: string) => {
    if (email.trim().length === 0) return true;
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  };

  const onSubmit = async (e:any) => {
    e.preventDefault();
    const { firstName,lastName, email, message } = e.target.elements;
    let details = {
      firstName: firstName.value,
      lastName: lastName.value,
      email: email.value,
      message: message.value,
    };
    console.log('Details - ',details)
    let response = await fetch(`/.netlify/functions/contact`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      body: JSON.stringify(details),
    });
    let result = await response.json();
    setResponse(result);
    setOpen(true);
    //alert(result.result);
  };
  const [open, setOpen] = React.useState(false);

  const handleSnackbarClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (<>
    {
      response && ( <Snackbar open={open} autoHideDuration={10000} onClose={handleSnackbarClose}>
<Alert onClose={handleSnackbarClose} severity={response.status==='error' ? "error" : "success"}>
<AlertTitle>{response.status==='error' ? "Error" : "Success"}</AlertTitle>
{response.message}
  </Alert></Snackbar>

      )
    }
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div style={{ fontFamily: "poiret", fontSize: "35px" }}>
        Thanks for being here 😊
      </div>
      <GradientDiv style={{marginTop: '31px',padding: '25px'}}>
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <img src={WriteToUsIcon} alt="write to us" />
        </Avatar>
        <Typography component="h1" variant="h5">
          Write to us
        </Typography>
        <form className={classes.form} onSubmit={onSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                autoComplete="fname"
                name="firstName"
                variant="outlined"
                required
                fullWidth
                id="firstName"
                label="First Name"
                autoFocus
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                fullWidth
                id="lastName"
                label="Last Name"
                name="lastName"
                autoComplete="lname"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                onChange={(e) => {
                  setEmailIsValid(validateEmail(e.target.value));
                }}
                helperText={
                  !emailIsValid ? (
                    <span style={{color: '#a20000',fontSize: '13px'}}>Invalid Email</span>
                  ) : null
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="outlined-multiline-static"
                label="Message"
                multiline
                fullWidth
                name="message"
                rows={6}
                defaultValue=""
                variant="outlined"
              />
            </Grid>
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
             style={{backgroundColor:'#5986ca'}}
            
            className={classes.submit}
            disabled={!emailIsValid}
          >
            Send
          </Button>
          <Link to='/' style={{textDecoration: 'none'}}> 
        <Button
            fullWidth
            variant="contained"
            color="primary"
             style={{backgroundColor:'#5986ca'}}
            
            className={classes.submit}
          >
            Back to Home
          </Button>
        </Link>
        </form>
      
      </div>
      </GradientDiv>
      <Box mt={5}>
        <Copyright />
      </Box>
    </Container>
    </>
  );
}
